import { createV3Queries } from "@query/utils/createV3Queries";
import { rolesApi } from "@api";

export const queriesRoles = createV3Queries("rolesApi", rolesApi);
